import { SRGBColorSpace, NoToneMapping, WebGLRenderer } from 'three'
import Experience from './Experience.js'
// import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
// import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
// import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

export default class Renderer {
    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera
        this.ui = this.experience.ui

        this.setInstance()
    }

    setInstance() {
        this.clearColor = '#010101'

        this.instance = new WebGLRenderer( {
            powerPreference: "high-performance",
            antialias: true,
            alpha: false,
            stencil: false,
            depth: false,
            useLegacyLights: false,
            physicallyCorrectLights: false,
        } )

        this.canvas = this.ui.html.hero.appendChild( this.instance.domElement )

        this.instance.outputColorSpace = SRGBColorSpace
        this.instance.toneMapping = NoToneMapping

        this.instance.setPixelRatio( Math.min( this.sizes.pixelRatio, 2 ) )

        this.instance.setClearColor( this.clearColor, 1 )
        this.instance.setSize( this.sizes.hero.width, this.sizes.hero.height )
    }

    update() {
        this.productionRender()
    }

    productionRender() {
        this.instance.render( this.scene, this.camera.instance )
    }

    resize() {
        this.instance.setSize( this.sizes.hero.width, this.sizes.hero.height )
        this.instance.setPixelRatio( this.sizes.pixelRatio )
    }

    destroy() {
        if (this.instance) {
            this.instance.dispose()
            this.instance = null
        }

        if (this.canvas && this.canvas.parentNode) {
            this.canvas.parentNode.removeChild(this.canvas)
        }
        this.canvas = null

        this.experience = null
        this.sizes = null
        this.scene = null
        this.camera = null
        this.ui = null

        this.clearColor = null
    }
}
